import { WidgetProps } from "@rjsf/utils";
import { useMemo } from "react";

import { useGmwListQuery } from "@/queries/query-gmw";

export const GmwSelect = ({ schema, uiSchema: _uiSchema, value, ...rest }: WidgetProps) => {
  const { ui: field, ...uiSchema } = _uiSchema || {};
  const { registry } = rest;

  const { data, isLoading } = useGmwListQuery({
    broIdIcontains: value ?? "",
  });
  const { EnumOrInput } = registry.widgets;

  const gmwOptions = useMemo(
    () =>
      (data?.results ?? [])
        .sort((a, b) => a.broId.localeCompare(b.broId))
        .map((gmw) => ({
          label: gmw.broId,
          value: gmw.broId,
        })),
    [data]
  );

  return (
    <EnumOrInput
      {...rest}
      value={value}
      isLoading={isLoading}
      schema={{
        ...schema,
        enum: gmwOptions.map((option) => option.value),
      }}
      uiSchema={{
        ...uiSchema,
        "ui:enumNames": gmwOptions.map((option) => option.label),
      }}
    />
  );
};
